import { render, staticRenderFns } from "./fmAssessRiskRegisterPop.vue?vue&type=template&id=6595db2c"
import script from "./fmAssessRiskRegisterPop.vue?vue&type=script&lang=js"
export * from "./fmAssessRiskRegisterPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6595db2c')) {
      api.createRecord('6595db2c', component.options)
    } else {
      api.reload('6595db2c', component.options)
    }
    module.hot.accept("./fmAssessRiskRegisterPop.vue?vue&type=template&id=6595db2c", function () {
      api.rerender('6595db2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/riskRegister/fmAssessRiskRegisterPop.vue"
export default component.exports